import React from "react";
import { Helmet } from "react-helmet-async";
import loadable from "@loadable/component";

import "assets/css/components/performance-refresh/_index.scss";
import "assets/css/pages/_performance.scss";

const ComponentWrapper = loadable(() =>
  import("../components/performance-refresh/ComponentWrapper")
);

const Performance = (props) => {
  const { route } = props;

  return (
    <>
      <Helmet>
        <title>{route?.meta?.title}</title>
        <meta name="title" content={route?.meta?.title} />
        <meta name="description" content={route?.meta?.description} />
      </Helmet>
      <ComponentWrapper />
    </>
  );
};

export default Performance;
